/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiLoginMutationRequest,
  PostApiLoginMutationResponse,
} from '../models/PostApiLogin.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiLoginMutationResponseSchema,
  postApiLoginMutationRequestSchema,
} from '../zod/postApiLoginSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiLoginMutationKey = () => [{ url: '/api/login' }] as const;

export type PostApiLoginMutationKey = ReturnType<
  typeof postApiLoginMutationKey
>;

/**
 * {@link /api/login}
 */
export async function postApiLogin(
  data: PostApiLoginMutationRequest,
  config: Partial<RequestConfig<PostApiLoginMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiLoginMutationRequestSchema.parse(data);
  const res = await request<
    PostApiLoginMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiLoginMutationRequest
  >({
    method: 'POST',
    url: `/api/login`,
    data: requestData,
    ...requestConfig,
  });
  return postApiLoginMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/login}
 */
export function usePostApiLogin<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiLoginMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiLoginMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiLoginMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiLoginMutationKey();

  return useMutation<
    PostApiLoginMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiLoginMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiLogin(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
